/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamInboxPoolingState } from '../../models/team-inbox-pooling-state';

export interface GlobalPoolingTeamInbox$Params {
  conversationReference?: string;
  phoneCompanyReference: string;
}

export function globalPoolingTeamInbox(http: HttpClient, rootUrl: string, params: GlobalPoolingTeamInbox$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamInboxPoolingState>> {
  const rb = new RequestBuilder(rootUrl, globalPoolingTeamInbox.PATH, 'get');
  if (params) {
    rb.query('conversationReference', params.conversationReference, {});
    rb.query('phoneCompanyReference', params.phoneCompanyReference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamInboxPoolingState>;
    })
  );
}

globalPoolingTeamInbox.PATH = '/v1/api/ui/conversation/team-inbox/pooling';
